import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const UserEmptyState = {
  users: [],
  selectedUser: null,
};

export const UserID = 'users';

export const usersSlice = createSlice({
  name: 'users',
  initialState: getLocalStorage(LocalStorageTypes.USERS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.USERS))
    : UserEmptyState,
  reducers: {
    setUsers: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.USERS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedUser: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(UserID, result);
      return { ...state, ...action.payload };
    },
    resetUsers: () => {
      clearLocalStorage('users');
      return UserEmptyState;
    },
  },
});

export const { setUsers, updateSelectedUser, resetUsers } = usersSlice.actions;
